import { render, staticRenderFns } from "./ImageUploadView.vue?vue&type=template&id=07e8b23e&scoped=true&"
import script from "./ImageUploadView.vue?vue&type=script&lang=js&"
export * from "./ImageUploadView.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadView.vue?vue&type=style&index=0&id=07e8b23e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8b23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('07e8b23e', component.options)
    } else {
      api.reload('07e8b23e', component.options)
    }
    module.hot.accept("./ImageUploadView.vue?vue&type=template&id=07e8b23e&scoped=true&", function () {
      api.rerender('07e8b23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/ImageUploadView.vue"
export default component.exports